import { render, staticRenderFns } from "./PageView.vue?vue&type=template&id=1bc0a770&"
import script from "./PageView.vue?vue&type=script&lang=js&"
export * from "./PageView.vue?vue&type=script&lang=js&"
import style0 from "./PageView.vue?vue&type=style&index=0&id=1bc0a770&prod&lang=scss&"
import style1 from "./PageView.vue?vue&type=style&index=1&id=1bc0a770&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports